import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { getData, addData, updateData, deleteData, getmetaTags } from '../../../services/admin/seoConfig/seoContextPageServices';
import { Modal, Button, Form } from 'react-bootstrap';
import DataTable from 'react-data-table-component';
import Header from '../../../components/Layout/Header';
import Footer from '../../../components/Layout/Footer';
import Sidebar from '../../../components/Layout/Sidebar';
import Spinner from '../../../components/Spinner';
import Swal from 'sweetalert2';


const Seocontextpage = () => {
const [dataList, setDataList] = useState([]);
const [form, setForm] = useState({ id: '',meta_tags: '', status: false
});
const [modalType, setModalType] = useState('');
const [showModal, setShowModal] = useState(false);
const [showDeleteConfirmModal, setShowDeleteConfirmModal] = useState(false);
const [searchText, setSearchText] = useState('');
const [currentPage, setCurrentPage] = useState(1);
const [selectedData, setSelectedData] = useState(null);
const [metaTags, setmetaTags] = useState([]);
const [loading, setLoading] = useState(true);
const [errors, setErrors] = useState({});

// Fetch data list
const fetchData = useCallback(async () => {
    try {
    const data = await getData();
    setDataList(data);
    } catch (error) {
    console.error('Failed to fetch data:', error);
    }
}, []);

useEffect(() => {
    const fetchDataAsync = async () => {
        setLoading(true); 
        await fetchData(); 
        // Optional 2 second delay
        await new Promise((resolve) => setTimeout(resolve, 1000));
        setLoading(false); 
      };
    
      fetchDataAsync();
}, [fetchData]);


  useEffect(() => {
    const fetchmetaTags = async () => {
      try {
        const data = await getmetaTags(); // Fetch data from the service
        setmetaTags(data); // Set the types in state
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    fetchmetaTags();
  }, []);

  const handleChange = (e) => {
    const { name, value} = e.target;
  
    // Define val properly
    let val = value;
    if (name === 'status') {
      val = value === '1'; // Convert string to boolean
    }
  
    setForm((prev) => ({
      ...prev,
      [name]: val,
    }));
  
    // Clear error for the field
    setErrors((prev) => ({ ...prev, [name]: '' }));
  };
  

  
  
  const handleDelete = async () => {
      if (selectedData) {
      // Optimistically remove the data from the list
      setDataList((prev) => prev.filter((data) => data.id !== selectedData.id));
      // Proceed with the actual delete request
      await deleteData(selectedData);
      setShowDeleteConfirmModal(false);
      }
  };

   const validateForm = () => {
  const newErrors = {};

  if (!form.meta_tags.trim()) newErrors.meta_tags = 'Meta tags is required';

  // ✅ Status can be false, so check specifically for null or undefined
  if (form.status === null || form.status === undefined) {
    newErrors.status = 'Status is required';
  }

  setErrors(newErrors);
  return Object.keys(newErrors).length === 0;
};

const handleSubmit = async (e) => {
  e.preventDefault(); // ✅ should be first

  if (!validateForm()) return;

  let updatedForm = { ...form };

  try {
    if (modalType === 'add') {
      await addData(updatedForm);
    } else if (modalType === 'edit') {
      console.log("Updating with form:", updatedForm); // ✅ DEBUGGING
      await updateData(updatedForm); // ✅ Ensure this sends valid `id`
    }

    await fetchData(); // ✅ Refresh the list
    setShowModal(false);

    Swal.fire({
      icon: 'success',
      title: 'Success',
      text: `SEO context page ${modalType === 'add' ? 'added' : 'updated'} successfully!`,
      timer: 2000,
      showConfirmButton: false,
    });
  } catch (error) {
    console.error('Error during form submission:', error);
    Swal.fire({
      icon: 'error',
      title: 'Error',
      text: 'Something went wrong while submitting the form!',
    });
  }
};

const openModal = (type, data = { id: '', meta_tags: '', status: false }) => {
  setErrors({});
  setModalType(type);

  // ✅ Ensure ID and booleans are set correctly
  setForm({
    id: data.id || '',
    meta_tags: data.meta_tags || '',
    status: data.status === true || data.status === 1,
  });

  setShowModal(true);
};


const handleSearchChange = (e) => {
    setSearchText(e.target.value);
};

const handlePageChange = (page) => {
    setCurrentPage(page);
};

const openDeleteConfirmModal = (data) => {
    setSelectedData(data);
    setShowDeleteConfirmModal(true);
};

// Memoized filtered data based on search query
const filteredData = useMemo(() => {
    return dataList.filter(
    (data) =>
        data.meta_tags.toLowerCase().includes(searchText.toLowerCase())
    ).sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt)); // Descending by updatedAt
}, [dataList, searchText]);

const columns = [
    {
    name: '#',
    selector: (row, index) => (currentPage - 1) * 10 + (index + 1),
    sortable: false,
    width: '10%',
    },
    {
    name: 'Meta Tags',
    selector: (row) => row.meta_tags	,
    sortable: true,
    wrap:true,
    width:"20%"
    },
    {
        name: 'Status',
        cell: (row) => (
            <span className={`badge ${Number(row.status) === 1 ? 'bg-success' : 'bg-danger'}`}>
            {Number(row.status) === 1 ? 'Active' : 'Inactive'}
            </span>
        ),
        sortable: true,
        wrap:true,
        width:"20%"
        },
                 
        {
        name: 'Actions',
        cell: (row) => (
            <div>
            <Button className="me-2" variant="warning" size="sm" onClick={() => openModal('edit', row)} > Edit </Button>
            <Button variant="danger" size="sm" onClick={() => openDeleteConfirmModal(row)} > Delete </Button>
            </div>
        ),
        wrap:true,
        width:"20%"
        },
];

return (
    <div className="d-flex">
    <Sidebar />
    <div className="main-content w-100">
        <Header />
        {loading ? (
                        <div
                          className="d-flex justify-content-center align-items-center w-100"
                          style={{ minHeight: "300px" }}
                        >
                          <Spinner /> {/* Centered Spinner */}
                        </div>
                                ) :(
                <div>
        <div className="container-fluid p-4">
        <div className="row">
            <div className="col-8">
            <p className='fs-4 text-dark'>General Configuration / Seo Config / SEO Context Page</p>
            </div>
            <div className="col-4 text-end">
            <button className="btn btn-primary mb-3" onClick={() => openModal('add')}>
                Add
            </button>
            </div>
        </div>

        <DataTable
            columns={columns}
            data={filteredData}
            pagination
            search
            highlightOnHover
            responsive
            striped
            paginationPerPage={10}
            paginationComponentOptions={{
            noRowsPerPage: true,
            }}
            onChangePage={handlePageChange}
            subHeader
            subHeaderComponent={
            <div>
                <input className="form-control" type="text" placeholder="Search" value={searchText}
                onChange={handleSearchChange}
                />
            </div>
            }
        />

        {/* Modal for Add/Edit data */}
        <Modal show={showModal} backdrop="static" className='modal-lg' onHide={() => setShowModal(false)}>
            <Modal.Header closeButton>
            <Modal.Title>{modalType === 'add' ? 'Add' : 'Edit'}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
            <Form>      
                <div className='row'>      
                <Form.Group className="col-md-6 mb-3">
                <Form.Label className='fs-5 text-dark'>Meta Tags <small className='fs-5 text-danger'>*</small></Form.Label>
                <Form.Control className="form-select mb-3" as="select" name="meta_tags" value={form.meta_tags} onChange={handleChange} isInvalid={!!errors.meta_tags}>
                    <option value="">Select</option>
                    {metaTags.map((metaTags) => (
                        <option key={metaTags.page_title} value={metaTags.page_value}>
                        {metaTags.page_title}
                        </option>
                    ))}
                </Form.Control>
                <Form.Control.Feedback type="invalid">  {errors.meta_tags} </Form.Control.Feedback>
                </Form.Group>
                
                <Form.Group className="col-md-6 mb-3">
                    <Form.Label>Status</Form.Label>
                    <Form.Select
                    name="status"
                    value={form.status ? '1' : '0'}
                    onChange={handleChange}
                    >
                    <option>Select</option>
                    <option value="1">Active</option>
                    <option value="0">Inactive</option>
                    </Form.Select>
                </Form.Group>
                                                      
                </div>  
            </Form>
            </Modal.Body>
            <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowModal(false)}> Cancel </Button>
            <Button variant="primary" onClick={handleSubmit}> {modalType === 'add' ? 'Add' : 'Save'} </Button>
            </Modal.Footer>
        </Modal>

         {/* Delete Confirmation Modal */}
                <Modal show={showDeleteConfirmModal} onHide={() => setShowDeleteConfirmModal(false)}>
                    <Modal.Header closeButton>
                    <Modal.Title>Delete</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                    <p>Are you sure you want to delete this row?</p>
                    </Modal.Body>
                    <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowDeleteConfirmModal(false)}>
                        Cancel
                    </Button>
                    <Button variant="danger" onClick={handleDelete}>
                        Yes, Delete
                    </Button>
                    </Modal.Footer>
                </Modal>
        </div>
        <Footer />
        </div>
      )};
    </div>
    </div>
);
};

export default Seocontextpage;